import { MARQUEE_ITEMS } from "../data";

export const Marquee = () => {
  const row = MARQUEE_ITEMS.map((t, i) => (
    <span className="mq-item" key={i}>
      {t} <span className="mq-star" aria-hidden="true">&#10022;</span>
    </span>
  ));
  return (
    <div className="marquee" aria-hidden="true" data-testid="services-marquee">
      <div className="mq-track">
        {row}
        {row}
      </div>
    </div>
  );
};
